<template>
  <StackPageLayout @close="handleClose">
    <template #title> New Product </template>

    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <ProductForm @submit="handleSubmit" />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import type { ProductFormOuput } from "@/forms/productForm"
import { createProduct } from "@/services/products/createProduct"

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const router = useRouter()

const handleClose = () =>
  router.push({ name: "settingsProductIndex" })

const handleSubmit = async (params: ProductFormOuput) => {
  startLoading()
  try {
    await createProduct({ ...params, tagIds: [] })
    toast.success("Product created")
    router.push({ name: "settingsProductIndex" })
  } catch {
    toast.error("Failed to create product")
  } finally {
    stopLoading()
  }
}
</script>
